/**
 * Visit Vehicle
 */
 export class VisitVehicle {
  /**
   * visit Id
   */
  visitId: number;

  /**
   * plate
   */
  plate: string;

  /**
   * card
   */
  card: string;

  /**
   * authorization Date
   */
  authorizationDate: Date;

  /**
   * user Authorization
   */
  userAuthorization: string;

  /**
   * user Authorization
   */
  permissionType: number;

  /**
   * Time Permit Visit
   */
  timePermitVisit: number;

  /**
   * initial Entry Date
   */
  initialEntryDate: Date;

  /**
   * end Date Entry
   */
  endDateEntry: Date;

  /**
   * final Exit Date
   */
  finalExitDate: Date;

  /**
   * end Date Absolute Exit
   */
  endDateAbsoluteExit: Date;

  /**
   * client Id
   */
  clientId: number;

  /**
   * authorized
   */
  authorized: boolean;

  /**
   * entry Movement
   */
  entryMovement: number;

  /**
   * entry Date
   */
  entryDate: Date;

  /**
   * exit Movement
   */
  exitMovement: number;

  /**
   * exit Date
   */
  exitDate: Date;

  /**
   * situation
   */
  situation: number;

  /**
   * collect Date
   */
  collectDate: Date;

  /**
   * collect User
   */
  collectUser: string;

  /**
   * amount
   */
  amount: number;

  /**
   * description
   */
  description: string;

  /**
   * priority
   */
  priority: boolean;

  /**
   * expiration
   */
  expiration: string;

  /**
   * type Vehicle
   */
  typeVehicle: string;

  /**
   * visitor
   */
  visitor: string;

  /**
   * visited
   */
  visited: string;

  /**
   * enclosure
   */
  enclosure: number;

  /**
   * last Entry
   */
  lastEntry: Date;

  /**
   * last Exit
   */
  lastExit: Date;
  /**
   * id Card
   */
  idCard: string;
  /**
   * email
   */
  email: string;
  /**
   * mobile
   */
  mobile: string;
  /**
   * departamentId
   */
  departamentId: number;
  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns MasterVehicle instance
   */
  static createFromJson(json: object): VisitVehicle {
    const self = new this();

    Object.keys(json).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }
}
